import { DatePicker, Select, Button } from "antd";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { useSearchParams } from "react-router-dom";

import "./DashboardHeader.css";

const DashboardHeader = ({
  userIds,
  setUserId,
  setStartDate,
  setEndDate,
  setHeaderChange,
  authStore,
  store,
}) => {
  const navigate = useNavigate();
  const [params, setParams] = useState({});
  const [init, setInit] = useState(false);
  const [defaultUserId, setDefaultUserId] = useState("");
  const [internalUserId, setInternalUserId] = useState("");
  const [defaultStartDate, setDefaultStartDate] = useState(null);
  const [internaStartDate, setInternalStartDate] = useState(null);
  const [defaultEndDate, setDefaultEndDate] = useState(null);
  const [internalEndDate, setInternalEndDate] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();

  const { Option } = Select;

  useState(() => {
    const queryUserId = searchParams.get("userId");
    const queryStartDate = searchParams.get("startDate");
    const queryEndDate = searchParams.get("endDate");
    const params = {};

    if (queryUserId) {
      params["userId"] = queryUserId;
    }
    if (queryStartDate) {
      params["startDate"] = queryStartDate;
    }
    if (queryEndDate) {
      params["endDate"] = queryEndDate;
    }
    setParams(params);
    if (!init) {
      setTimeout(() => {
        if (queryUserId) {
          setDefaultUserId(queryUserId);
          setUserId(queryUserId);

          store.user = { userid: queryUserId };
          store.useridsWithDateRange.forEach((record) => {
            if (record.userid === queryUserId) {
              store.user = record;
            }
          });
        }
        if (queryStartDate) {
          setDefaultStartDate(moment(new Date(queryStartDate)));
          setStartDate(queryStartDate.substring(0, 10));
        }
        if (queryEndDate) {
          setDefaultEndDate(moment(new Date(queryEndDate)));
          setEndDate(queryEndDate.substring(0, 10));
        }
        if (userIds && userIds.length === 1 && !queryUserId) {
          userIdChange(userIds[0]);
        }

        setHeaderChange(true);

        setInit(true);
      }, 1);
    }
  }, []);

  useEffect(() => {
    const queryStartDate = searchParams.get("startDate");
    const queryEndDate = searchParams.get("endDate");
    if (queryStartDate || queryEndDate) {
      return;
    }
    if (store.user && store.user.min_datetime) {
      setDefaultStartDate(moment(new Date(store.user.min_datetime)));
      setStartDate(store.user.min_datetime.substring(0, 10));
    } else if (authStore.userTimerange) {
      setDefaultStartDate(
        moment(new Date(authStore.userTimerange.min_datetime))
      );
      setStartDate(authStore.userTimerange.min_datetime.substring(0, 10));
    } else {
      const aWeekAgo = moment(new Date()).add(-7, "days");
      setDefaultStartDate(aWeekAgo);
      setStartDate(aWeekAgo.format().substring(0, 10));
    }
    if (store.user && store.user.max_datetime) {
      setDefaultEndDate(moment(new Date(store.user.max_datetime)));
      setEndDate(store.user.max_datetime.substring(0, 10));
    } else if (authStore.userTimerange) {
      setDefaultEndDate(moment(new Date(authStore.userTimerange.max_datetime)));
      setEndDate(authStore.userTimerange.max_datetime.substring(0, 10));
    } else {
      setDefaultEndDate(moment(new Date()));
      setEndDate(moment(new Date()).format().substring(0, 10));
    }
  }, [authStore.userTimerange, store.user]);

  const userIdChange = (value) => {
    store.user = { userid: value };
    store.useridsWithDateRange.forEach((record) => {
      if (record.userid === value) {
        store.user = record;
      }
    });

    setUserId(value);
    setInternalUserId(value);
    setHeaderChange(true);
    setParams({ ...params, userId: value });
    const url =
      "/detail-chart/?" +
      new URLSearchParams({ ...params, userId: value }).toString();
    navigate(url);
  };

  const startDateChange = (value) => {
    if (value) {
      setInternalStartDate(value);
      setStartDate(value.toISOString().substring(0, 10));
      setHeaderChange(true);
      const valueStr = moment(value).format();
      setParams({ ...params, startDate: valueStr });
      const url =
        "/detail-chart/?" +
        new URLSearchParams({ ...params, startDate: valueStr }).toString();
      navigate(url);
    }
  };
  const endDateChange = (value) => {
    if (value) {
      setInternalEndDate(value);
      setEndDate(value.toISOString().substring(0, 10));
      setHeaderChange(true);
      const valueStr = moment(value).format();
      setParams({ ...params, endDate: valueStr });
      const url =
        "/detail-chart/?" +
        new URLSearchParams({ ...params, endDate: valueStr }).toString();
      navigate(url);
    }
  };

  const reset = () => {
    store.updateResetEventChart();
  };

  return (
    <div className="controls">
      <div className="controls__item">
        Start Date
        <DatePicker
          format={["MM/DD/YYYY"]}
          bordered={false}
          onChange={startDateChange}
          value={internaStartDate || defaultStartDate}
        />
      </div>
      <div className="controls__item">
        End Date
        <DatePicker
          format={["MM/DD/YYYY"]}
          bordered={false}
          onChange={endDateChange}
          value={internalEndDate || defaultEndDate}
        />
      </div>
      {["admin", "org_admin", "org_supervisor"].indexOf(authStore.userRole) <
        0 && (
        <div className="controls__item" style={{ marginTop: "5px" }}>
          {userIds[0]}
        </div>
      )}
      {["admin", "org_admin", "org_supervisor"].indexOf(authStore.userRole) >=
        0 && (
        <div className="controls__item">
          User
          <Select
            value={internalUserId || defaultUserId}
            bordered={false}
            style={{ width: 160 }}
            onChange={userIdChange}
          >
            {userIds &&
              userIds.map((userid, i) => {
                return (
                  <Option value={userid} key={`user-id-${i}`}>
                    {userid}
                  </Option>
                );
              })}
          </Select>
        </div>
      )}
      {store.timeseries && store.timeseries.length > 0 && (
        <React.Fragment>
          <div
            className="controls__item rightAlign"
            style={{ marginLeft: "auto" }}
          >
            <div style={{ marginRight: "10px" }}>
              {store.events && store.events.length > 0 && (
                <Button onClick={() => store.toggleHideTable()}>
                  {!store.hideEventTable ? "Hide Table" : "Show Table"}
                </Button>
              )}
            </div>
          </div>
          {
            <div className="controls__item rightAlign">
              {store.events && store.events.length > 0 && (
                <div style={{ marginRight: "10px" }}>
                  <Button
                    disabled={store.bounds && store.bounds[0] == null}
                    onClick={reset}
                  >
                    Reset
                  </Button>
                </div>
              )}
            </div>
          }
        </React.Fragment>
      )}
    </div>
  );
};

export default observer(DashboardHeader);
